// src/components/SampleOrders.jsx
import React, { useEffect, useState } from "react";
import projectData from "./projectData";
import ProductModal from "../catalog/ProductModal";
import sampleProducts from "../catalog/sampleProducts";
import sampleModalConfig from "../catalog/sampleModalConfig";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const laminateOptions = [
  {
    label: "Merino 21027 SF",
    value: "irish-cream",
    image:
      "https://www.merinolaminates.com/sites/default/files/styles/laminate_detail/public/2023-08/21027.png",
  },
  {
    label: "Merino 14538 VNR",
    value: "american-walnut",
    image:
      "https://www.merinolaminates.com/sites/default/files/styles/laminate_detail/public/2023-08/14538.png",
  },
];

function SampleOrders() {
  const [projects, setProjects] = useState(projectData);
  const [selectedModule, setSelectedModule] = useState(null);
  const [highlightedRows, setHighlightedRows] = useState(new Set());
  const [selectedLaminate, setSelectedLaminate] = useState(
    laminateOptions[0].value
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleUpdate = (e) => {
    e.preventDefault();
    const orig = selectedModule;
    const updatedDim = `${e.target.h.value} x ${e.target.w.value} x ${e.target.d.value}`;
    const updatedColor = laminateOptions.find(
      (o) => o.value === selectedLaminate
    ).label;
    const updatedMinifix = e.target.minifix.value === "yes";

    setProjects((prev) =>
      prev.map((proj) => ({
        ...proj,
        sections: proj.sections.map((sec) => ({
          ...sec,
          modules: sec.modules.map((mod) =>
            mod.id === orig.id
              ? {
                  ...mod,
                  dimensions: updatedDim,
                  color: updatedColor,
                  minifix: updatedMinifix,
                }
              : mod
          ),
        })),
      }))
    );

    if (
      updatedDim !== orig.dimensions ||
      updatedColor !== orig.color ||
      updatedMinifix !== orig.minifix
    ) {
      setHighlightedRows((prev) => new Set(prev).add(orig.id));
    }

    setSelectedModule(null);
  };

  const selectedColorLabel = laminateOptions.find(
    (o) => o.value === selectedLaminate
  ).label;

  return (
    <div className="container-fluid py-4 px-0">
      <h2 className="mb-4 text-start fw-bold fs-2 border-bottom mx-5 pb-4 border-secondary">
        Sample Orders
      </h2>

      {projects.map((project, pjIdx) => (
        <div
          key={project.id}
          className={`mb-5 p-4 rounded ${pjIdx % 2 ? "bg-light" : "bg-white"}`}
        >
          <div className="row gx-5 align-items-start">
            {/* Left: image + markers */}
            <div className="col-lg-5 position-relative">
              <img
                src={project.image}
                className="img-fluid rounded h-100 object-fit-cover"
                alt="Project"
              />
              {project.sections
                .flatMap((sec) => sec.modules)
                .map((mod) => (
                  <div
                    key={mod.id}
                    style={{
                      position: "absolute",
                      left: `${mod.position.left * 100}%`,
                      top: `${mod.position.top * 100}%`,
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    {/* <div
                      className="d-flex align-items-center justify-content-center bg-white text-dark rounded-circle border"
                      style={{
                        width: 24,
                        height: 24,
                        fontSize: "0.8rem",
                        fontWeight: 600,
                      }}
                    >
                      {mod.label}
                    </div> */}
                  </div>
                ))}
            </div>

            {/* Right: sections & tables */}
            <div className="col-lg-7 fs-6">
              <div className="list-group list-group-flush">
                {project.sections.map((section) => (
                  <div
                    key={section.name}
                    className="list-group-item p-0 border-0 bg-transparent mb-3"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0 fw-bold">{section.name}</h5>
                      <Button
                        color="link"
                        size="sm"
                        onClick={() => (window.location.href = "/register")}
                        className="text-primary"
                      >
                        Show total price
                      </Button>
                    </div>
                    <div className="d-flex flex-wrap gap-2 mb-2">
                      {section.specs &&
                        Object.entries(section.specs).map(([key, value]) => (
                          <div
                            key={key}
                            className="px-2 py-1 border small rounded-2"
                            style={{
                              backgroundColor: "#fafafa",
                              borderColor: "#e0e0e0",
                            }}
                          >
                            <span className="text-primary fw-semibold me-1">
                              {key}:
                            </span>
                            <span>{value}</span>
                          </div>
                        ))}
                    </div>
                    <div className="table-responsive px-0">
                      <table className="table table-bordered table-sm mb-4">
                        <thead
                          className="table-light fw-normal"
                          style={{ fontSize: "0.8em" }}
                        >
                          <tr>
                            <th className="text-secondary">LABEL</th>
                            <th className="text-secondary">SKU</th>
                            <th className="text-secondary">MODULE</th>
                            <th className="text-secondary">DIMENSIONS</th>
                            <th className="text-secondary">COLOR</th>
                            <th className="text-secondary">MINIFIX</th>
                            <th className="text-secondary">PRICE</th>
                          </tr>
                        </thead>
                        <tbody className="text-muted">
                          {section.modules.map((mod) => (
                            <tr
                              key={mod.id}
                              className={
                                highlightedRows.has(mod.id)
                                  ? "table-warning"
                                  : ""
                              }
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                const base =
                                  sampleProducts.find(
                                    (p) => p.sku === mod.sku
                                  ) || {};

                                const merged = {
                                  ...base,
                                  dimensions: mod.dimensions,
                                  color: mod.color,
                                  minifix: mod.minifix,
                                  id: mod.id,
                                  label: mod.label,
                                  name: mod.name,
                                  sku: mod.sku,
                                };

                                setSelectedModule({
                                  product: merged,
                                  config: sampleModalConfig,
                                });
                                const match = laminateOptions.find(
                                  (o) => o.label === mod.color
                                );
                                setSelectedLaminate(
                                  match ? match.value : laminateOptions[0].value
                                );
                              }}
                            >
                              <td className="py-2 text-center">{mod.label}</td>
                              <td className="py-2">{mod.sku}</td>
                              <td className="py-2">{mod.name}</td>
                              <td className="py-2 text-nowrap">
                                {mod.dimensions}
                              </td>
                              <td className="py-2">{mod.color}</td>
                              <td className="py-2">
                                {mod.minifix ? "Yes" : "No"}
                              </td>
                              <td
                                className="py-2 text-primary"
                                onClick={() =>
                                (window.location.href = "/register")
                                }
                              >
                                Show
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Modal */}
      {selectedModule && (
        <ProductModal
          open={!!selectedModule}
          onClose={() => setSelectedModule(null)}
          product={selectedModule.product}
          config={selectedModule.config}
        />
      )}
    </div>
  );
}

export default SampleOrders;
